import { createFileRoute } from "@tanstack/react-router";

import { allMyBookmarksQueryOptions } from "@/features/bookmarks/queries";
import { MemberCaseDetailPage } from "@/features/cases/member-case-detail-page";
import { myApplicationForCaseQueryOptions } from "@/features/cases/queries";

// ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
export const Route = createFileRoute("/_authenticated/member/$id/")({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(myApplicationForCaseQueryOptions(params.id)),
      // 保存ボタンの状態判定に使う自分の保存済み一覧を先読み。
      context.queryClient.ensureQueryData(allMyBookmarksQueryOptions()),
    ]);
  },
  component: MemberCaseDetailPage,
});
